/*
 * @@Author: MuYang
 */

import mergeOptions from '../pretreatment/merge-options'
import {_createNode, _createOtherNode} from './create-node'
import store, {insetField, initStoreCatch, insetSchemaNode, insetRulesMap} from '../store'
import {createdSubRules} from '../rule'
import { getI18 } from '../../index'

let _uid = 0

// 创建schema
export function createdSchema ({data, page}, schemaPayload = {}) {
  const {pageType = 'list', config = {}, _id = _uid, btnsEvent, subPages, scopedSlots, subObjectParamName, i18ApiName} = schemaPayload

  const {objectApiName, app, _objectApiName} = data.info
  let layoutApiName = data.info.layoutApiName || data.info.apiName
  const _config = config[objectApiName]
  // 获取数据集
  const i18Maps = getI18(i18ApiName || objectApiName) || {}
  const {fieldMap, buttonMap, mainField, info, integrationConfig, _codeApiNameRelation} = mergeOptions({data, page}, {config: _config, btnsEvent, layoutApiName, objectApiName, app, _id, _objectApiName, i18Maps})
  // store 插入 fieldMap
  insetField(_id, fieldMap, objectApiName)

  // 创建其他节点  移动端
  _createOtherNode(page.layout, {
    fieldMap, buttonMap, objectApiName, _id, scopedSlots, info: data.info, pageType, i18Maps, _codeApiNameRelation, quoteFieldsMap: data.quoteFieldsMap, config: _config,
  })
  // 弹框页面
  if (!subObjectParamName && page.layout?.info?.showType === 'window') {
    page.layout.targetType = 'popup'
  }
  // 生成当前schema
  const schema = _createNode(page.layout, {
    i18Maps,
    info,
    mainField,
    fieldMap,
    buttonMap,
    pageType,
    _id,
    subPages,
    scopedSlots,
    rowKey: config.rowKey,
    layoutApiName,
    objectApiName,
    subObjectParamName,
    app,
    rule: data.rule,
    config: _config,
    _codeApiNameRelation,
    ability: data.ability,
    quoteFieldsMap: data.quoteFieldsMap,
    integrationConfig
  })

  schema._id = _id
  schema.info = info
  schema.i18Maps = i18Maps
  return schema
}

// 初始化schema
export async function initSchema ({schema, subSchema = []}, payload = {}) {
  _uid += 1
  initStoreCatch(_uid)
  // 获取主对象业务config
  const _payload = {...payload}
  _payload._id = _uid
  const _schema = createdSchema(schema, {
    ..._payload,
    isMain: true,
    i18ApiName: schema.objectApiName,
    subPages: schema.data.subPages
  })
  processSub(subSchema, _payload, schema.objectApiName)
  return {
    nodes: _schema,
    _type: 'root',
    _id: _uid,
    info: _schema.info,
    subSchema,
    pageRule: schema.data?.rule?.pageRule,
    cache: {
      fieldMap: store.cache[_uid].fieldMap,
      columnMap: store.cache[_uid].columnMap,
      buttonMap: store.cache[_uid].buttonMap
    }
  }
}

// 处理从对象schema
function processSub (subSchema = [], payload, parentObjectApiName) {
  if (subSchema.length === 0) {
    return
  }
  subSchema.forEach(sub => {
    //处理主对象
    const _schema = createdSchema(sub, {
      ...payload,
      i18ApiName: parentObjectApiName,
      subObjectParamName: sub.subObjectParamName
    })
    _schema.viewContent.forEach(node => {
      if (node.targetType === 'cards') {
        node.masterRelationInfo = _schema.info
      }
    })
    // 插入到节点位置
    insetSchemaNode(payload._id, parentObjectApiName, sub.layoutSeqCode, _schema.viewContent)
    insetRulesMap(payload._id, createdSubRules(sub.data?.rule?.slaveRule), sub.layoutApiName)
  })
}

// // 处理参数
// function processSchema (schema, payload) {
//   const _config = payload?.config?.[schema.subObjectParamName || schema.objectApiName]
//   const config = assign({}, _config)
//   return {...payload,  config}
// }
